module.exports = /** by json loader */{
	"networkTimeout": {},
	"pages": [
		"./main/index",
		"./main/wode",
		"./main/huizong/quanxian_gl",
		"./main/huizong/caozuo_xx",
		"./main/cibao/weiquan_zj",
		"./main/guanli/goutong_hf",
		"./main/huizong/suzhuang_gl",
		"./main/userDialog/login",
		"./main/guanli/jingying_gl",
		"./main/cibao/benji_dl",
		"./main/tijiao_y",
		"./wxsys/comps/user/userDialog/authorize",
		"./main/guanli/suzhuang_sc",
		"./main/huizong/fapiao_gl",
		"./wxsys/comps/user/userDialog/changePassword",
		"./main/userDialog/forgetPassword",
		"./main/userDialog/register",
		"./main/cibao/suxin_tx",
		"./main/userDialog/authorize",
		"./main/cibao/yonghu_xy",
		"./main/userDialog/user",
		"./main/cibao/yiyi_xq",
		"./main/cibao/weiquan_wg",
		"./wxsys/comps/user/userDialog/register",
		"./main/wode_jy",
		"./main/huizong/yewu_gl",
		"./main/huizong/goutong_xx",
		"./main/huizong/yewu_xq",
		"./wxsys/comps/user/userDialog/login",
		"./main/guanli/yiyi_qr",
		"./main/huizong/jinyan_xx",
		"./main/huizong/yonghu_xx",
		"./main/yiyi_jy",
		"./main/userDialog/bindphone",
		"./wxsys/comps/user/userDialog/user",
		"./main/cibao/suzhuang_xz",
		"./main/guanli/susong_xx",
		"./main/guanli/fapiao_sc",
		"./main/cibao/weiquan_cy",
		"./main/puguang_ply",
		"./main/huizong/weiquan_xx",
		"./main/huizong/yijian_jy2",
		"./main/guanli/weiquan_sh",
		"./main/cibao/yiyi_tj",
		"./main/guanli/weiquan_zh",
		"./main/huizong/beiyong",
		"./main/cibao/falv_wq",
		"./wxsys/comps/user/userDialog/bindphone",
		"./main/lianxi_wm",
		"./main/userDialog/changePassword",
		"./main/huizong/yiyi_xx",
		"./main/huizong/susong_xx2",
		"./main/cibao/canyu_qr",
		"./main/guanli/jinyan_gl",
		"./main/huizong/weiquan_gz",
		"./wxsys/comps/user/userDialog/forgetPassword",
		"./main/guanli/jianyi_qr",
		"./main/guanli/weiquan_fh",
		"./main/wode_wq"
	],
	"debug": false,
	"appName": "预帮惠",
	"tabBar": {
		"position": "bottom",
		"selectedColor": "#0d70b7",
		"borderStyle": "white",
		"list": [
			{
				"selectedIconPath": "./main/images/1shouyexuanzhong.png",
				"text": "首页",
				"pagePath": "./main/index",
				"iconPath": "./main/images/1shouyeweixuanzhong.png"
			},
			{
				"selectedIconPath": "./main/images/1wodixuanzhong.png",
				"text": "我的",
				"pagePath": "./main/wode",
				"iconPath": "./main/images/1wodiweixuanzhong.png"
			}
		]
	},
	"permission": {
		"scope.userLocation": {
			"desc": "使用当前位置信息标记商家所在地"
		}
	},
	"window": {
		"navigationStyle": "default",
		"navigationBarBackgroundColor": "#0d70b7",
		"navigationBarTitleText": "预帮惠"
	}
};


//////////////////
// WEBPACK FOOTER
// ./pages/app.json
// module id = ./pages/app.json
// module chunks = 22